export default __webpack_public_path__ + "static/media/csv.6808ca4f.svg";